// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1927e0dd","453":"0ec77a0d","455":"00aae936","644":"03883c61"}[chunkId] + ".chunk.js";
};